module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\n  <app-polizas-agregar-view></app-polizas-agregar-view>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas-agregar/polizas-agregar.component.html
// module id = ./src/app/Contabilidad/polizas/polizas-agregar/polizas-agregar.component.html
// module chunks = main